import types from '../types';
import API from '../../../lib/api';
import ModalsLib from '../../../lib/modals';
import {toast} from 'react-toastify';

export const createOrder = data => async dispatch => {
    // Disable button and clear error
    dispatch({
        type: types.zelle_deposit.updateStageData,
        payload: {
            error: null,
            ...data, // Save new data
            button: true
        }
    });

    // Make API request
    const response = await API.call({
        path: '/payments/client/zelle/deposit',
        method: 'POST',
        body: data
    });

    if(!response.success) {
        dispatch({
            type: types.zelle_deposit.updateStageData,
            payload: {
                error: response.error,
                button: false
            }
        });
    } else {
        dispatch({
            type: types.zelle_deposit.order,
            payload: response.order
        });

        dispatch({
            type: types.zelle_deposit.updateStageData,
            payload: {
                button: false
            }
        });

        dispatch({
            type: types.zelle_deposit.setStage,
            payload: 'notice'
        });
    }
}

export const agreeNotice = () => {
    return {
        type: types.zelle_deposit.setStage,
        payload: 'confirm'
    }
}


export const setStage = stage => {
    return {
        type: types.zelle_deposit.setStage,
        payload: stage
    }
}
